import { DashboardLoginPage } from "@dashboard/components/DashboardLoginPage"
import { createFileRoute } from "@tanstack/react-router"

type LoginSearch = {
  returnTo?: string
  error?: string
}

export const Route = createFileRoute("/login")({
  validateSearch: (search): LoginSearch => ({
    returnTo: typeof search.returnTo === "string" ? search.returnTo : undefined,
    error: typeof search.error === "string" ? search.error : undefined,
  }),
  component: LoginRoute,
})

function LoginRoute() {
  const search = Route.useSearch()
  return (
    <DashboardLoginPage
      returnTo={search.returnTo}
      routeError={search.error}
    />
  )
}
